export const calculateDistance = (
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number,
) => {
    const toRad = (angle: number) => (angle * Math.PI) / 180;
    const R = 3959; // Earth's radius in miles

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lng2 - lng1);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = R * c;

    return distance; // in miles
};
